import { h }            from "preact";
import { PureComponent,
         ScrollTop }    from "shared-components";
import styles           from "./styles.scss";
import classNames       from "classnames";
import { connect }      from "preact-redux";
import Helmet           from "preact-helmet";

import { load    as loadCategory,
         PENDING as PROCUREMENT_PENDING } from "reducers/procurement";

import { put as putCart }   from "reducers/cart";

import Checkout     from "containers/Checkout";
import Review       from "containers/Review";
import CheckoutForm from "components/CheckoutForm";
import ProductCard  from "components/ProductCard";
import Wrapper      from "components/Wrapper";

import MovieQtyPicker     from "../../components/MovieQtyPicker";
import SimpleQtyPicker     from "../../components/SimpleQtyPicker";

const SIMPLE_SKUS = [
  "27416",
  "27415",
  "27413",
  "27411",
  "27410",
  "27409",
];

@connect(
  state    => ({
    categoryLoaded  : state.procurement.loaded,
    categoryPending : state.procurement.state === PROCUREMENT_PENDING,
    products        : state.procurement.data.products,
    cart            : state.cart.data,
  }),
  dispatch => ({
    loadCategory : id => dispatch(loadCategory(id)),
    putCart      : (items) => dispatch(putCart(items)),
  }),
)
export default class Procurement extends PureComponent {
  static defaultProps = {
    products : []
  };

  componentWillMount() {
    if (!this.props.categoryLoaded && this.props.categoryPending) {
      this.props.loadCategory(76);
    }
  }

  render({ products, putCart }: Props, _state: any, { t }: Context) {
    return (
      <section
          class={classNames(
            this.props["class"],
            styles.block
          )}>

        <div class={styles.wrapper}>
          <section class={styles.productsContainer}>
            {products.map(product =>
              <div class={styles.column}>
                <ProductCard
                    product={product}
                    class={classNames(
                      styles.section
                    )}
                />

                {SIMPLE_SKUS.includes(product.sku) ?
                  <SimpleQtyPicker
                    product={product}
                    basePrice={product.originalPrice}
                    msrp={product.msrp}
                    putCart={putCart}
                  />
                :
                  <MovieQtyPicker
                    product={product}
                    basePrice={product.originalPrice}
                    msrp={product.msrp}
                    putCart={putCart}
                  />
                }
              </div>
            )}
          </section>

          <CheckoutForm
              class={classNames(
                "row__medium",
                styles.section
              )}
          />

          <section class={styles.reviewContainer}>
            <div class={styles.column}>
              <Review class={styles.section} />
            </div>
            <div class={styles.column}>
              <Checkout class={styles.section} />
            </div>
          </section>

          <p style={{ float: "right" }} dangerouslySetInnerHTML={{ __html: t("CHECKOUT.INFO") }} />
        </div>

        <ScrollTop />

        <Helmet
            title={t("PROCUREMENT.TITLE")}
        />
      </section>
    );
  }
}
